import {
  CREATEGATEWAYMAPPING_SUCCESS,
  CREATEGATEWAYMAPPING_FAILED,
  RESET_CREATEGATEWAYMAPPING,
  LOADING_CREATEGATEWAYMAPPING,
  NETWORK_ERROR_CREATEGATEWAYMAPPING,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetCreateGatewayMapping = () => {
  return { type: RESET_CREATEGATEWAYMAPPING };
};

const createGatewayMapping = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_CREATEGATEWAYMAPPING });
  await adminServices
    .post("createGatewayMapping", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.responseCode) {
        case "1":
          dispatch(createGatewayMappingsuccess(res.data));
          break;
        default:
          dispatch(createGatewayMappingFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_CREATEGATEWAYMAPPING, payload: err });
    });
};
function createGatewayMappingsuccess(data) {
  return {
    type: CREATEGATEWAYMAPPING_SUCCESS,
    payload: data,
  };
}
function createGatewayMappingFailed(data) {
  return {
    type: CREATEGATEWAYMAPPING_FAILED,
    payload: data,
  };
}

export { resetCreateGatewayMapping, createGatewayMapping };
